import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { SIZES } from 'common/constants/sizes';
import { multiLineEllipsis } from 'common/utils/text.utils';

const fontStyle = ({ italic }) => (italic ? 'italic' : 'normal');
const textDecoration = ({ underline }) => (underline ? 'underline' : 'none');
const textTransform = ({ textTransform }) =>
  textTransform ? textTransform : 'none';

// eslint-disable-next-line
/**
 * @deprecated please use the typography component from `@linearb/linui-common/typography`
 */
export const Inline = styled.span`
  font-size: ${props => SIZES[props.size || 'small']};
  color: ${props => getColor(props.color)};
  text-align: ${props => props.align || 'start'};
  font-weight: ${props => props.weight || 400};
  letter-spacing: ${props => props.letterSpacing || ''};
  line-height: ${props => props.lineHeight || 'normal'};
  text-decoration: ${props => props.decoration || 'none'};
  text-transform: ${props => props.transform || 'none'};
  white-space: ${props => (props.allowBreaks ? 'pre-wrap' : 'initial')};
  font-style: ${fontStyle};
  ${({ multiLineEllipsisAfter }) =>
    multiLineEllipsisAfter ? multiLineEllipsis(multiLineEllipsisAfter) : ''};
  ${props => (props.cursor ? `cursor: ${props.cursor}` : '')};
  ${props => (props.width ? `width: ${props.width}` : '')};
  ${props => (props.minWidth ? `min-width: ${props.minWidth}` : '')};
  ${props => (props.maxWidth ? `max-width: ${props.maxWidth}` : '')};
  ${props =>
    props.ellipsisAfter
      ? ellipsis(props.ellipsisAfter, props.customDisplay)
      : null};
  ${props => (props.pl ? `padding-left: ${props.pl}` : '')};
  ${props => (props.pr ? `padding-right: ${props.pr}` : '')};
  ${props => (props.pb ? `padding-bottom: ${props.pb}` : '')};
  ${props => (props.pt ? `padding-top: ${props.pt}` : '')};
`;

const ellipsis = (maxWidth, customDisplay) => `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: ${maxWidth};
  ${customDisplay ? `display: ${customDisplay}` : ''}
`;

const wrap = maxWidth => {
  const [min, max] = Array.isArray(maxWidth)
    ? maxWidth
    : [null, maxWidth === true ? null : maxWidth];
  return `
    white-space: pre-wrap;
    max-width: ${max || 'initial'};
    min-width: ${min || 'initial'};
  `;
};

export const ErrorDescription = styled.div`
  padding-top: 0.5rem;
  color: ${getColor('torchRed')};
  ${({ minHeight }) => (minHeight ? `min-height: ${minHeight}` : '')};
`;

// eslint-disable-next-line
/**
 * @deprecated please use the typography component from `@linearb/linui-common/typography`
 */
const Text = styled.p`
  box-sizing: content-box;
  margin: 0;
  font-size: ${({ size }) => SIZES[size || 'small']};
  color: ${({ color }) => getColor(color || 'shark')};
  text-align: ${({ align }) => align || 'start'};
  font-weight: ${({ weight }) => weight || 'normal'};
  letter-spacing: ${({ letterSpacing }) => letterSpacing || 'normal'};
  font-style: ${fontStyle};
  text-decoration: ${textDecoration};
  text-transform: ${textTransform};
  line-height: ${({ lineHeight }) => lineHeight || 'normal'};
  ${({ whiteSpace }) => (whiteSpace ? `white-space: ${whiteSpace}` : '')};
  ${({ ellipsisAfter }) => (ellipsisAfter ? ellipsis(ellipsisAfter) : '')};
  ${({ multiLineEllipsisAfter }) =>
    multiLineEllipsisAfter ? multiLineEllipsis(multiLineEllipsisAfter) : ''};
  ${({ allowBreaks }) => (allowBreaks ? wrap(allowBreaks) : '')};
  ${({ cursor }) => (cursor ? `cursor: ${cursor}` : '')};
  ${({ padding }) => (padding ? `padding: ${padding}` : '')};
  ${({ pl }) => (pl ? `padding-left: ${pl}` : '')};
  ${({ pr }) => (pr ? `padding-right: ${pr}` : '')};
  ${({ pt }) => (pt ? `padding-top: ${pt}` : '')};
  ${({ pb }) => (pb ? `padding-bottom: ${pb}` : '')};
  ${({ mb }) => (mb ? `margin-bottom: ${mb}` : '')};
  ${({ mt }) => (mt ? `margin-top: ${mt}` : '')};
  ${({ ml }) => (ml ? `margin-left: ${ml}` : '')};
  ${({ mr }) => (mr ? `margin-right: ${mr}` : '')};
  ${({ disabled }) => (disabled ? `color: ${getColor('osloGray')}` : '')};
  ${({ letterSpacing = 'normal' }) => `letter-spacing:${letterSpacing}`};
  ${({ width }) => (width ? `width: ${width}` : '')};
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}` : '')};
  ${({ whiteSpace }) => (whiteSpace ? `white-space: ${whiteSpace}` : '')};
  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${getColor(backgroundColor)}` : ''};
`;
Text.displayName = 'Text';

// eslint-disable-next-line
/**
 * @deprecated please use the typography component from `@linearb/linui-common/typography`
 */
export default Text;
